import { Fade } from '@mui/material';
import { useAtom } from 'jotai';
import { IMPORT_MODAL_DEFAULTS, importModalAtom } from '@/atoms/import';
import { usePrefValue } from '@/preferences';
import { ImportModal, ImportModalContent, ImportModalWrap } from './ImportScript.styles';
import { ImportScriptForm } from './ImportScriptForm';
import { ImportScriptLoader } from './ImportScriptLoader';

export const ImportScriptModal = () => {
    const side_bar = usePrefValue('side_bar');
    const [importModal, setImportModal] = useAtom(importModalAtom);
    const open = importModal.open;

    const handleOnClose = () => {
        setImportModal(() => IMPORT_MODAL_DEFAULTS);
    };

    return (
        <ImportModal open={open} onClose={handleOnClose}>
            {/* biome-ignore lint/complexity/noUselessFragments: MUI Modal requires non-null children */}
            <>
                {open ? (
                    <Fade in={open}>
                        <ImportModalWrap>
                            <ImportModalContent sideBar={side_bar}>
                                <ImportScriptForm />
                            </ImportModalContent>
                            <ImportScriptLoader />
                        </ImportModalWrap>
                    </Fade>
                ) : null}
            </>
        </ImportModal>
    );
};
